import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const FETCH_ACCOUNT_GROUP_NAME = gql`
  query fetchAccountGroup($id: ObjectID!) {
    fetchAccountGroup(accountGroupId: $id) {
      accountGroup { translatedName { ${TRANSLATED_STRING_FIELDS} } }
    }
  }
`;

export function AccountGroupBreadcrumb() {
  const { t } = useTranslation();
  const { accountGroupId } = useParams();
  const { data } = useQuery(FETCH_ACCOUNT_GROUP_NAME, {
    variables: { id: accountGroupId },
  });

  return (
    translateBackend(data?.fetchAccountGroup?.accountGroup?.translatedName) ||
    t('client:accountGroup')
  );
}
